<script lang="ts">
	import AmountInput from '$lib/AmountInput.svelte';
	import { trackEvent } from '$lib/utils/mixpanel';
	import { defaults, superForm } from 'sveltekit-superforms';
	import { zod } from 'sveltekit-superforms/adapters';
	import { z } from 'zod';
	import Button from './Button.svelte';

	interface Props {
		monthlyIncome: number | undefined;
		currentStep: number;
	}

	let { monthlyIncome = $bindable(), currentStep = $bindable() }: Props = $props();

	const schema = z.object({
		monthlyIncome: z.number().positive()
	});

	const { form, enhance, allErrors, validateForm } = superForm(
		defaults(
			{
				monthlyIncome: 5000
			},
			zod(schema)
		),
		{
			SPA: true,
			validators: zod(schema),
			dataType: 'json',
			resetForm: false,
			onUpdate({ form }) {
				if (form.valid) {
					monthlyIncome = form.data.monthlyIncome;
					currentStep++;
					trackEvent('Money Habits Tracker - Step 1', {
						monthlyIncome
					});
				}
			}
		}
	);

	validateForm({
		update: true
	});
</script>

<form use:enhance>
	<AmountInput
		label="Monthly Income"
		labelClass="h3 mb-3 block"
		id="monthlyIncome"
		bind:value={$form.monthlyIncome}
		placeholder="Enter your monthly income"
		type="currency"
		class="mb-5"
	/>

	<Button disabled={$allErrors.length > 0} class="w-full">NEXT</Button>
</form>
